import { Check } from "lucide-react"

import { cn } from "@/lib/utils"
import type { QuizStep } from "../../types"

interface Props {
  step: QuizStep
  value: string[]
  onChange: (value: string[]) => void
}

export function MultipleChoiceStep({ step, value, onChange }: Props) {
  const toggle = (optionValue: string) => {
    if (value.includes(optionValue)) {
      onChange(value.filter((v) => v !== optionValue))
    } else if (step.maxSelect == null || value.length < step.maxSelect) {
      onChange([...value, optionValue])
    }
  }

  return (
    <div className="space-y-3">
      {step.options?.map((option) => {
        const checked = value.includes(option.value)
        return (
          <button
            key={option.value}
            type="button"
            onClick={() => toggle(option.value)}
            className={cn(
              "flex h-14 w-full items-center justify-between rounded-xl border px-4 text-left text-base transition-colors",
              step.boldOptions ? "font-bold" : "font-medium",
              checked
                ? "border-main-purple bg-purple-light/10 text-purple-light"
                : "border-transparent bg-purple-light/10 text-purple-light hover:bg-purple-light/15",
            )}
          >
            {option.label}
            {checked && <Check className="size-5 shrink-0 text-main-purple" />}
          </button>
        )
      })}
    </div>
  )
}
